import { SquareDashedMousePointer } from 'lucide-react';
import { TbDatabaseImport, TbRefreshDot, TbUpload, TbWebhook, TbWorldCode } from 'react-icons/tb';

import { ListViewColumnDataType } from '@/types';

import { ListColumnStyleParams } from './types';

export const createBaseListColumns = ({ categoryIconStyle, token }: ListColumnStyleParams) => {
    const peopleListColumns = [
        {
            key: 'person',
            label: 'Name',
            dataType: ListViewColumnDataType.SHORT_TEXT,
            categories: [
                {
                    key: 'dataUpload',
                    label: 'Data Upload',
                    icon: <TbDatabaseImport style={{ ...categoryIconStyle }} />,
                },
            ],
            icon: <TbUpload style={{ color: token.colorTextTertiary }} />,
            handler: async () => {},
        },
        {
            key: 'title',
            label: 'Title',
            dataType: ListViewColumnDataType.SHORT_TEXT,
            categories: [
                {
                    key: 'dataUpload',
                    label: 'Data Upload',
                    icon: <TbDatabaseImport style={{ ...categoryIconStyle }} />,
                },
            ],
            icon: <TbUpload style={{ color: token.colorTextTertiary }} />,
            handler: async () => {
                return;
            },
        },
        {
            key: 'emailAddress',
            label: 'Email Address',
            dataType: ListViewColumnDataType.EMAIL,
            categories: [
                {
                    key: 'dataFetching',
                    label: 'Data Fetching',
                    icon: <TbRefreshDot style={{ ...categoryIconStyle }} />,
                },
            ],
            icon: <TbWorldCode style={{ color: token.colorTextTertiary }} />,
            handler: async () => {
                return;
            },
        },
        {
            key: 'connectionStrength',
            label: 'Connection Strength',
            dataType: ListViewColumnDataType.SELECT,
            categories: [
                {
                    key: 'dataFetching',
                    label: 'Data Fetching',
                    icon: <TbRefreshDot style={{ ...categoryIconStyle }} />,
                },
            ],
            icon: <TbWorldCode style={{ color: token.colorTextTertiary }} />,
            handler: async () => {
                return;
            },
        },
        {
            key: 'status',
            label: 'Status',
            dataType: ListViewColumnDataType.STATUS,
            categories: [
                {
                    key: 'dataFetching',
                    label: 'Data Fetching',
                    icon: <TbRefreshDot style={{ ...categoryIconStyle }} />,
                },
            ],
            icon: <TbWorldCode style={{ color: token.colorTextTertiary }} />,
            handler: async () => {
                return;
            },
        },
        {
            key: 'company',
            label: 'Key Company',
            dataType: ListViewColumnDataType.MULTIRELATION,
            categories: [
                {
                    key: 'dataFetching',
                    label: 'Data Fetching',
                    icon: <TbRefreshDot style={{ ...categoryIconStyle }} />,
                },
                {
                    key: 'realTimeEvents',
                    label: 'Real-Time Events',
                    icon: <SquareDashedMousePointer size='0.75rem' style={{ ...categoryIconStyle }} />,
                },
            ],
            icon: <TbWebhook style={{ color: token.colorTextTertiary }} />,
            handler: async () => {
                return;
            },
        },
        {
            key: 'lastEmailInteraction',
            label: 'Last Email Interaction',
            dataType: ListViewColumnDataType.DATE,
            categories: [
                {
                    key: 'dataFetching',
                    label: 'Data Fetching',
                    icon: <TbRefreshDot style={{ ...categoryIconStyle }} />,
                },
                {
                    key: 'realTimeEvents',
                    label: 'Real-Time Events',
                    icon: <SquareDashedMousePointer size='0.75rem' style={{ ...categoryIconStyle }} />,
                },
            ],
            icon: <TbWebhook style={{ color: token.colorTextTertiary }} />,
            handler: async () => {
                return;
            },
        },
        {
            key: 'lastCalendarInteraction',
            label: 'Last Calendar Interaction',
            dataType: ListViewColumnDataType.DATE,
            categories: [
                {
                    key: 'dataFetching',
                    label: 'Data Fetching',
                    icon: <TbRefreshDot style={{ ...categoryIconStyle }} />,
                },
                {
                    key: 'realTimeEvents',
                    label: 'Real-Time Events',
                    icon: <SquareDashedMousePointer size='0.75rem' style={{ ...categoryIconStyle }} />,
                },
            ],
            icon: <TbWebhook style={{ color: token.colorTextTertiary }} />,
            handler: async () => {
                return;
            },
        },
        {
            key: 'nextEmailInteraction',
            label: 'Next Email Interaction',
            dataType: ListViewColumnDataType.DATE,
            categories: [
                {
                    key: 'dataFetching',
                    label: 'Data Fetching',
                    icon: <TbRefreshDot style={{ ...categoryIconStyle }} />,
                },
                {
                    key: 'realTimeEvents',
                    label: 'Real-Time Events',
                    icon: <SquareDashedMousePointer size='0.75rem' style={{ ...categoryIconStyle }} />,
                },
            ],
            icon: <TbWebhook style={{ color: token.colorTextTertiary }} />,
            handler: async () => {
                return;
            },
        },
        {
            key: 'nextCalendarInteraction',
            label: 'Next Calendar Interaction',
            dataType: ListViewColumnDataType.DATE,
            categories: [
                {
                    key: 'dataFetching',
                    label: 'Data Fetching',
                    icon: <TbRefreshDot style={{ ...categoryIconStyle }} />,
                },
                {
                    key: 'realTimeEvents',
                    label: 'Real-Time Events',
                    icon: <SquareDashedMousePointer size='0.75rem' style={{ ...categoryIconStyle }} />,
                },
            ],
            icon: <TbWebhook style={{ color: token.colorTextTertiary }} />,
            handler: async () => {
                return;
            },
        },
    ];
    
    const companyListColumns = [
        {
            key: 'company',
            label: 'Company',
            dataType: ListViewColumnDataType.MULTIRELATION,
            categories: [
                {
                    key: 'dataUpload',
                    label: 'Data Upload',
                    icon: <TbDatabaseImport style={{ ...categoryIconStyle }} />,
                },
            ],
            icon: <TbUpload style={{ color: token.colorTextTertiary }} />,
            handler: async () => {
                return;
            },
        },
        {
            key: 'website',
            label: 'Website',
            dataType: ListViewColumnDataType.URL,
            categories: [
                {
                    key: 'dataFetching',
                    label: 'Data Fetching',
                    icon: <TbRefreshDot style={{ ...categoryIconStyle }} />,
                },
            ],
            icon: <TbWorldCode style={{ color: token.colorTextTertiary }} />,
            handler: async () => {
                return;
            },
        },
        {
            key: 'categories',
            label: 'Categories',
            dataType: ListViewColumnDataType.MULTISELECT,
            categories: [
                {
                    key: 'dataFetching',
                    label: 'Data Fetching',
                    icon: <TbRefreshDot style={{ ...categoryIconStyle }} />,
                },
            ],
            icon: <TbWorldCode style={{ color: token.colorTextTertiary }} />,
            handler: async () => {
                return;
            },
        },
        {
            key: 'linkedin',
            label: 'LinkedIn',
            dataType: ListViewColumnDataType.URL,
            categories: [
                {
                    key: 'dataFetching',
                    label: 'Data Fetching',
                    icon: <TbRefreshDot style={{ ...categoryIconStyle }} />,
                },
            ],
            icon: <TbWorldCode style={{ color: token.colorTextTertiary }} />,
            handler: async () => {
                return;
            },
        },
        {
            key: 'twitter',
            label: 'Twitter / X',
            dataType: ListViewColumnDataType.URL,
            categories: [
                {
                    key: 'dataFetching',
                    label: 'Data Fetching',
                    icon: <TbRefreshDot style={{ ...categoryIconStyle }} />,
                },
            ],
            icon: <TbWorldCode style={{ color: token.colorTextTertiary }} />,
            handler: async () => {
                return;
            },
        },
        {
            key: 'address',
            label: 'Headquarters',
            dataType: ListViewColumnDataType.ADDRESS,
            categories: [
                {
                    key: 'dataFetching',
                    label: 'Data Fetching',
                    icon: <TbRefreshDot style={{ ...categoryIconStyle }} />,
                },
                {
                    key: 'realTimeEvents',
                    label: 'Real-Time Events',
                    icon: <SquareDashedMousePointer size='0.75rem' style={{ ...categoryIconStyle }} />,
                },
            ],
            icon: <TbWebhook style={{ color: token.colorTextTertiary }} />,
            handler: async () => {
                return;
            },
        },
        {
            key: 'city',
            label: 'City',
            dataType: ListViewColumnDataType.SHORT_TEXT,
            categories: [
                {
                    key: 'dataFetching',
                    label: 'Data Fetching',
                    icon: <TbRefreshDot style={{ ...categoryIconStyle }} />,
                },
                {
                    key: 'realTimeEvents',
                    label: 'Real-Time Events',
                    icon: <SquareDashedMousePointer size='0.75rem' style={{ ...categoryIconStyle }} />,
                },
            ],
            icon: <TbWebhook style={{ color: token.colorTextTertiary }} />,
            handler: async () => {
                return;
            },
        },
        {
            key: 'stateProvinence',
            label: 'State',
            dataType: ListViewColumnDataType.SHORT_TEXT,
            categories: [
                {
                    key: 'dataFetching',
                    label: 'Data Fetching',
                    icon: <TbRefreshDot style={{ ...categoryIconStyle }} />,
                },
                {
                    key: 'realTimeEvents',
                    label: 'Real-Time Events',
                    icon: <SquareDashedMousePointer size='0.75rem' style={{ ...categoryIconStyle }} />,
                },
            ],
            icon: <TbWebhook style={{ color: token.colorTextTertiary }} />,
            handler: async () => {
                return;
            },
        },
        {
            key: 'zipCode',
            label: 'Zip Code',
            dataType: ListViewColumnDataType.NUMBER,
            categories: [
                {
                    key: 'dataFetching',
                    label: 'Data Fetching',
                    icon: <TbRefreshDot style={{ ...categoryIconStyle }} />,
                },
                {
                    key: 'realTimeEvents',
                    label: 'Real-Time Events',
                    icon: <SquareDashedMousePointer size='0.75rem' style={{ ...categoryIconStyle }} />,
                },
            ],
            icon: <TbWebhook style={{ color: token.colorTextTertiary }} />,
            handler: async () => {
                return;
            },
        },
        {
            key: 'foundingYear',
            label: 'Founding Year',
            dataType: ListViewColumnDataType.YEAR,
            categories: [
                {
                    key: 'dataFetching',
                    label: 'Data Fetching',
                    icon: <TbRefreshDot style={{ ...categoryIconStyle }} />,
                },
                {
                    key: 'realTimeEvents',
                    label: 'Real-Time Events',
                    icon: <SquareDashedMousePointer size='0.75rem' style={{ ...categoryIconStyle }} />,
                },
            ],
            icon: <TbWebhook style={{ color: token.colorTextTertiary }} />,
            handler: async () => {
                return;
            },
        },
    ];
    
    const financialListColumns = [
        {
            key: 'tickerSymbol',
            label: 'Ticker Symbol',
            dataType: ListViewColumnDataType.SHORT_TEXT,
            categories: [
                {
                    key: 'dataUpload',
                    label: 'Data Upload',
                    icon: <TbDatabaseImport style={{ ...categoryIconStyle }} />,
                },
            ],
            icon: <TbUpload style={{ color: token.colorTextTertiary }} />,
            handler: async () => {
                return;
            },
        },
        {
            key: 'capitalRaised',
            label: 'Capital Raised',
            dataType: ListViewColumnDataType.CURRENCY,
            categories: [
                {
                    key: 'dataFetching',
                    label: 'Data Fetching',
                    icon: <TbRefreshDot style={{ ...categoryIconStyle }} />,
                },
            ],
            icon: <TbWorldCode style={{ color: token.colorTextTertiary }} />,
            handler: async () => {
                return;
            },
        },
        {
            key: 'annualRevenue',
            label: 'Annual Revenue',
            dataType: ListViewColumnDataType.CURRENCY,
            categories: [
                {
                    key: 'dataFetching',
                    label: 'Data Fetching',
                    icon: <TbRefreshDot style={{ ...categoryIconStyle }} />,
                },
            ],
            icon: <TbWorldCode style={{ color: token.colorTextTertiary }} />,
            handler: async () => {
                return;
            },
        },
        {
            key: 'marketCapitalization',
            label: 'Market Capitalization',
            dataType: ListViewColumnDataType.CURRENCY,
            categories: [
                {
                    key: 'dataFetching',
                    label: 'Data Fetching',
                    icon: <TbRefreshDot style={{ ...categoryIconStyle }} />,
                },
            ],
            icon: <TbWorldCode style={{ color: token.colorTextTertiary }} />,
            handler: async () => {
                return;
            },
        },
        {
            key: 'enterpriseValue',
            label: 'Enterprise Value',
            dataType: ListViewColumnDataType.CURRENCY,
            categories: [
                {
                    key: 'dataFetching',
                    label: 'Data Fetching',
                    icon: <TbRefreshDot style={{ ...categoryIconStyle }} />,
                },
            ],
            icon: <TbWorldCode style={{ color: token.colorTextTertiary }} />,
            handler: async () => {
                return;
            },
        },
    ];

    return { peopleListColumns, companyListColumns, financialListColumns };
};
